export const useDefaultData = () => {

    const defaultDataModal = {
        open: false,
        titleModal: '',
        componentModal: '',
        dataRequest: {},
    }

    const defaultFormScreen = {
        idstamp: '',
        type_stamp: '',
        amount: '',
        stock: '',
    }

    return Object.freeze({
        defaultDataModal,
        defaultFormScreen
    })
}